import { getApiUrlForResource } from '../services/apiUrlResolver';

export const PERMISSIONS_RESOURCE_NAME = 'permissions';

const permissionsDataProvider = {
  resource: PERMISSIONS_RESOURCE_NAME,
  providerInterface: {
    providerRequestToHttpRequest: (type, params) => {
      const apiUrl = getApiUrlForResource(PERMISSIONS_RESOURCE_NAME);

      switch (type) {
        case 'GET_LIST':
          return {
            url: `${apiUrl}/permissions`,
          };
        default:
          throw new Error(`Unsupported request type: ${type}`);
      }
    },
    httpResponseToProviderData: (response, type, params) => {
      switch (type) {
        case 'GET_LIST': {
          const contentRange = response.headers.get('content-range');
          let total = response.json.length;
          if (contentRange) {
            const parts = contentRange.split('/');
            if (parts.length === 2) {
              total = parseInt(parts[1], 10);
            }
          }
          return {
            data: response.json,
            total: total,
          };
        }
        default:
          throw new Error(`Unsupported response type: ${type}`);
      }
    },
  },
};

export default permissionsDataProvider;
